import type { FileButtonProps as MantineFileButtonProps } from '@mantine/core';
import { FileButton as MantineFileButton } from '@mantine/core';

// `Multiple` has to stay generic: it's what types the `onChange` payload as `File[]` rather than
// `File | null`. Collapsing it to the default would silently reject every `multiple` call site.
export type FileButtonProps<Multiple extends boolean = false> = MantineFileButtonProps<Multiple>;

export const FileButton = <Multiple extends boolean = false>(props: FileButtonProps<Multiple>) => {
  return <MantineFileButton {...props} />;
};
